import client from 'api/client';
import { AxiosResponse, AxiosRequestConfig } from 'axios';
import { BackendEventProps, FrontendEventProps } from 'api/models/payload/EventsPayload';

export function user_props_get(
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<BackendEventProps>> {
    return client.get<BackendEventProps>('/user_props', customConfig);
}

export function user_props_put(
    userData: BackendEventProps,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<BackendEventProps>> {
    return client.put<BackendEventProps>('/user_props', userData, customConfig);
}

export function frontend_event_post(
    eventName: string,
    userData: FrontendEventProps,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<FrontendEventProps>> {
    return client.post<FrontendEventProps>(`/segment_event/${eventName}`, userData, customConfig);
}
